export default __webpack_public_path__ + "images/arrow_submit-586745ed26870e4d70bc8ad36c182904.svg";